import { AppPageHeader1 } from '@juvare/common-web-ui/AppPageHeader1';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import { SectionLink, SectionWithLinks } from '@juvare/common-web-ui/SectionWithLinks';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useConfigurationPages } from './hooks';

interface Group {
    label: string;
    links: SectionLink[];
}

const groups = {
    missions: 'Missions',
};

export const ConfigurationsPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <LayoutRows2
            row1={<AppPageHeader1 title={t('appHeader.settings.configurations')} />}
            row2={<ClassifierMenu />}
            fullHeightRow='row2'
            row2Scrollable={true}
        />
    );
};

const ClassifierMenu: React.FC = () => {
    const userState = useSelector(getUserState);
    const navigate = useNavigate();
    const { sortedConfigurationPages } = useConfigurationPages();

    if (!userState) {
        return null;
    }

    const uniqueGroups = Array.from(new Set(sortedConfigurationPages.map((page) => page.groupLabel))).sort();
    const sortedGroups = uniqueGroups.reduce<Group[]>((acc, group) => {
        const sortedLinks = sortedConfigurationPages
            .filter((page) => page.groupLabel === group)
            .map((page) => {
                const href = '/configurations/' + page.path;
                return {
                    href: href,
                    label: page.label,
                    onClick: () => {
                        navigate(href);
                    },
                };
            })
            .sort((a, b) => (a.label > b.label ? 1 : -1));

        return [...acc, { label: group, links: sortedLinks }];
    }, []);

    const missionsGroup = sortedGroups.filter((group) => group.label === groups.missions);
    const allowedGroups = requireAnySystemPermission(userState, 'manage-all-classifiers') ? sortedGroups : missionsGroup;

    return (
        <Box p={2}>
            {allowedGroups.map((group) => (
                <SectionWithLinks key={group.label} title={group.label} links={group.links} />
            ))}
        </Box>
    );
};
